// extracted by mini-css-extract-plugin
export default {"container":"S02_container__k4Gu8","limiter":"S02_limiter__MVDie","title":"S02_title__7jHCT"};